module.exports = __webpack_public_path__ + "img/181.c25c0d55.jpg";